import { app } from '@/lib/firebase';
import { getStripePayments } from '@stripe/firestore-stripe-payments';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe Payments
export const payments = getStripePayments(app, {
  productsCollection: 'products',
  customersCollection: 'customers',
});

// Initialize Stripe.js
export const stripePromise = loadStripe('pk_test_51QVFPPGKwh1I2qoYw9TUGMHh69x7igsJega1QfaU2ktzyKDvkrbx6Msf81FXZz2yAtSm7Vspe3lKTAIyTqrOYCZI00uPLUhZVO');